import { Stack, TextField, Typography, useTheme } from '@mui/material';
import { IconTilePicker } from './IconTilePicker';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { SYSTEM_MESSAGE_INTERNAL_DESCRIPTION_MAX } from 'constants/system-messages.constants';
import type { SystemMessageIconType as SystemMessageIconTypeValue } from 'constants/system-messages.constants';
import {
	getFormHintSx,
	getFormInputSx,
	getMaxLengthValidationText,
} from '../createForm.styles';
import { CreateFormFieldLabel } from './CreateFormFieldLabel';

type CreateFormMetadataSectionProps = {
	internalDescription: string;
	onInternalDescriptionChange: (value: string) => void;
	internalDescriptionTooLong: boolean;
	iconType: SystemMessageIconTypeValue;
	onIconTypeChange: (value: SystemMessageIconTypeValue) => void;
};

export const CreateFormMetadataSection = ({
	internalDescription,
	onInternalDescriptionChange,
	internalDescriptionTooLong,
	iconType,
	onIconTypeChange,
}: CreateFormMetadataSectionProps) => {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();
	const formInputSx = getFormInputSx(theme);
	const formHintSx = getFormHintSx(theme);

	return (
		<>
			<Stack spacing={0.75}>
				<CreateFormFieldLabel
					label={t('page.systemMessages.field.internalDescription')}
					charHint={t('page.systemMessages.charHint.internalDescription')}
				/>
				<TextField
					value={internalDescription}
					onChange={(event) => onInternalDescriptionChange(event.target.value)}
					placeholder={t('page.systemMessages.field.internalDescription.placeholder')}
					error={internalDescriptionTooLong}
					helperText={
						internalDescriptionTooLong
							? getMaxLengthValidationText(t, SYSTEM_MESSAGE_INTERNAL_DESCRIPTION_MAX)
							: undefined
					}
					fullWidth
					sx={formInputSx}
				/>
				<Typography sx={formHintSx}>{t('page.systemMessages.field.internalDescription.hint')}</Typography>
			</Stack>

			<Stack spacing={0.75}>
				<CreateFormFieldLabel label={t('page.systemMessages.field.iconType')} />
				<IconTilePicker value={iconType} onChange={onIconTypeChange} />
				<Typography sx={formHintSx}>{t('page.systemMessages.iconType.hint')}</Typography>
			</Stack>
		</>
	);
};
